import { useTriageToolbar } from "~/providers/triage-toolbar";
import { IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { TriageToolbarWrapper } from "~/components/TriageToolbar/TriageToolbarWrapper";
import { Flex } from "~/components/Flex";
import { TriageToolbarButtonRenderer } from "~/components/TriageToolbar/TriageToolbarButtonRenderer";
import { TriageToolbarSelection } from "~/components/TriageToolbar/TriageToolbarSelection";
import { Fragment } from "react/jsx-runtime";

export default function TriageToolbar() {
  const { visible, buttons, customContent, payload, hide } = useTriageToolbar();

  const handleClose = () => {
    payload?.onClose?.();
    hide();
  };

  if (!visible) return null;

  return (
    <TriageToolbarWrapper>
      <Flex justifyContent="space-between" width="100%">
        <Flex>
          <TriageToolbarSelection
            count={payload.count || 0}
            totalCount={payload.totalCount || 0}
          />
          {customContent ||
            buttons.map((btn, index) => {
              return (
                <Fragment key={`${btn.type} - ${index}`}>
                  <TriageToolbarButtonRenderer {...btn} />
                </Fragment>
              );
            })}
        </Flex>
        <Flex>
          <IconButton onClick={handleClose}>
            <CloseIcon sx={{ color: "common.white" }} />
          </IconButton>
        </Flex>
      </Flex>
    </TriageToolbarWrapper>
  );
}
